export default __webpack_public_path__ + "static/media/arrowRight.aec3fa24.svg";